import { createFileRoute } from '@tanstack/react-router';

import Account from '~/profile/Account';

export const Route = createFileRoute('/_protected/account/')({
  component: Account,
});
